import { UserLayout } from "@/components/layouts/user-layout"
import { MainContainer } from "@/components/ui/container"
import { PasswordForm } from "@/components/features/profiles/password-form"

export default function UserProfilesEditPassword() {
  return (
    <UserLayout>
      <MainContainer size="xs">
        <PasswordForm />
      </MainContainer>
    </UserLayout>
  )
}
